import {
  put,
  takeEvery,
  call
} from 'redux-saga/effects';
import * as actions from '../../actions/voucherPayment.actions';
import * as actionTypes from '../../actionTypes/ActionTypes';
import VoucherPaymentServices from '../../../services/voucherPaymentServices';

export default function* getByVoucherIdSaga() {
  yield takeEvery(actionTypes.VOUCHER_PAYMENT.GET_BY_VOUCHER_ID_REQUEST, getByVoucherId);
}

export function* getByVoucherId(action) {
  try {
    const response = yield call(VoucherPaymentServices.getByVoucherId, action.payload);
    if (response.success) {
      const { data } = response;
      yield put(actions.getByVoucherIdSuccess(data));
    } else {
      yield put(actions.getByVoucherIdFail(response.message));
    }
  } catch (error) {
    yield put(actions.getByVoucherIdFail(error));
  }
}
